<script>
import _ from 'lodash'
import service from '@/request/base'
import ImageService from '@/request/file/image'
import RecordImageService from '@/request/record/recordImage'
import RecordCourseService from '@/request/record/recordCourse'
import EberFiles from '@/components/EberFiles'
export default {
  name: 'RecordImageList',
  components: {
    EberFiles
  },
  props: {
    sourceId: {
      type: Number,
      default: 0
    },
    mark: {
      type: String,
      default: '医步'
    },
    source: {
      type: String,
      default: 'record'
    },
    classify: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: true
    },
    enableAdd: {
      type: Boolean,
      default: true
    },
    showImages: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      files: [],
      vpsoptions: {
        index: 0,
        thumbnailParentClass: 'eber-record-files-' + this._uid + '-' + this.sourceId,
        srcname: 'image',
        wname: 'width',
        hname: 'height',
        tname: 'remark',
        shareEl: false,
        shareButtons: [{
          id: 'remark',
          label: '备注',
          url: 'button'
        }, {
          id: 'download',
          label: '下载',
          url: '{{raw_image_url}}',
          download: true
        }]
      },
      showPhotoSwipe: false
    }
  },
  created () {
    this.setThumbnailParentClass()
    this.listImage()
  },
  computed: {},
  mounted () {},
  watch: {
    sourceId (newVal, oldVal) {
      this.setThumbnailParentClass()
      if (oldVal) {
        this.listImage()
      } else if (newVal) {
        this.saveImages().then(() => {
          this.listImage()
        }).catch(error => {
          this.$message.error(error)
        })
      } else {
        this.files = []
      }
    },
    classify () {
      if (!this.sourceId) {
        return
      }
      this.setThumbnailParentClass()
      this.listImage()
    },
  },
  methods: {
    setThumbnailParentClass () {
      let cls = 'eber-record-files-' + this._uid + '-' + (this.sourceId || this._uid) + '_'
      if (this.source === 'record') {
        cls += this.classify || 0
      } else if (this.source === 'course') {
        cls += 'course'
      }
      this.vpsoptions.thumbnailParentClass = cls
      return cls
    },
    listImage () {
      this.files = []
      if (!this.sourceId) {
        return
      }
      if (this.source === 'record') {
        this.listRecordImage()
      } else if (this.source === 'course') {
        this.listCourseImages()
      }
    },
    listRecordImage () {
      if (!this.sourceId) {
        this.files = []
        return
      }
      RecordImageService.listImage({
        rid: this.sourceId,
        classify: this.classify
      }).then(res => {
        this.files = _.sortBy(_.clone(res.result || []), ['orderNum'])
        for (let i = 0; i < this.files.length; i++) {
          this.files[i].thumbnail = service.url(this.files[i].thumbnail)
          this.files[i].image = service.url(this.files[i].image)
        }
      })
    },
    listCourseImages () {
      if (!this.sourceId) {
        this.files = []
        return
      }
      RecordCourseService.listImage({
        dcids: this.sourceId
      }).then(res => {
        this.files = _.sortBy(_.clone(res.result || []), ['orderNum'])
        for (let i = 0; i < this.files.length; i++) {
          this.files[i].thumbnail = service.url(this.files[i].thumbnail)
          this.files[i].image = service.url(this.files[i].image)
        }
      })
    },
    handleDeleteImage (options) {
      if (!this.sourceId) {
        if (options.tempid) {
          let index = _.findIndex(this.files, {'tempid': options.tempid})
          if (index < 0) {
            return
          }
          this.files.splice(index, 1)
        }
        return
      }
      if (!options || !options.id) {
        this.$message.error('图片信息有误，请刷新页面重试删除')
        return
      }
      let self = this
      let fn = RecordImageService.deleteImage
      if (this.source === 'course') {
        fn = RecordCourseService.deleteImage
      }
      self.$confirm('确认删除这张图片吗?', '提示', {type: 'warning'}).then(() => {
        fn({
          id: options.id
        }).then(() => {
          let index = _.findIndex(self.files, {'id': options.id})
          if (index >= 0) {
            self.files.splice(index, 1)
          }
          self.$emit('remove', options)
        }, err => {
          self.$message.error(err)
        }).catch(error => {
          self.$message.error(error || '删除图片失败')
        })
      }, () => {
        self.$message({
          message: '取消操作!',
          type: 'info'
        })
      })
    },
    handleRemarkImage (options) {
      if (!this.sourceId) {
        return
      }
      if (!options || !options.id) {
        this.$message.error('图片信息有误，请刷新页面重试删除')
        return
      }
      let index = _.findIndex(this.files, {'id': options.id})
      let imgObj = this.files[index]
      this.$prompt('', '批注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '请输入内容',
        inputType: 'textarea',
        inputValue: imgObj ? imgObj.remark : null,
        inputPattern: /\S+/,
        inputErrorMessage: '内容不能为空'
      }).then(({ value }) => {
        if (!imgObj) {
          return
        }
        let fn = RecordImageService.saveImage
        if (this.source === 'course') {
          fn = RecordCourseService.saveImage
        }
        imgObj.remark = value
        fn(imgObj).then(res => {
          let img = res.result
          img.thumbnail = service.url(img.thumbnail)
          img.image = service.url(img.image)
          this.$set(this.files, index, _.clone(img))
          this.$message({
            message: '备注成功',
            type: 'success'
          })
        }).catch(error => {
          this.$message.error(error || '备注失败')
        })
      }).catch(() => {
        this.$message({
          message: '取消操作',
          type: 'info'
        })
      })
    },
    handleBeforeUpload (file) {
      let type = file.type
      if (!type) {
        this.$message.error('文件:' + file.name + '的类型不正确')
        return false
      }
      if (type.indexOf('image/') !== 0 && type.indexOf('video/') !== 0) {
        this.$message.error('不支持文件:' + file.name + '的类型')
        return false
      }
      return true
    },
    handleUploadImage (options) {
      let self = this
      return new Promise((resolve, reject) => {
        let type = options.file.type
        if (type.indexOf('image/') === 0) {
          ImageService.uploadImage(options.file, self.mark, null, options.onProgress).then(uimg => {
            uimg = uimg.result
            if (!uimg) {
              reject(new Error('上传图片失败'))
            } else {
              resolve({
                type: 'image',
                data: uimg
              })
            }
          }).catch(error => {
            reject(error || new Error('上传图片失败'))
          })
        } else if (type.indexOf('video/') === 0) {
          ImageService.uploadVideo(options.file, options.onProgress).then(uvideo => {
            uvideo = uvideo.result
            if (!uvideo) {
              reject(new Error('上传视频失败'))
            } else {
              resolve({
                type: 'video',
                data: uvideo
              })
            }
          }).catch(error => {
            reject(error || new Error('上传视频失败'))
          })
        } else {
          reject(new Error('不支持的文件类型'))
        }
      })
    },
    handleUploadImageSuccess (data) {
      let type = data.type || 'image'
      data = data.data
      let thumbnail = type === 'image' ? data.small : data.cover
      let image = type === 'image' ? data.superSrc : data.location
      let img = {
        thumbnail: thumbnail,
        type: 0,
        orderNum: this.files.length + 1,
        image: image,
        width: data.width || 1024,
        height: data.height || 768,
        tempid: data.id
      }
      if (this.source === 'record') {
        img = _.defaultsDeep(img, {
          rid: this.sourceId,
          classify: this.classify
        })
      } else if (this.source === 'course') {
        img = _.defaultsDeep(img, {
          dcid: this.sourceId
        })
      }
      let temp = _.cloneDeep(img)
      temp.thumbnail = service.url(temp.thumbnail)
      temp.image = service.url(temp.image)
      this.files.push(temp)
      this.files = _.sortBy(this.files, ['orderNum'])
      if (!this.sourceId) {
        return
      }
      let fn = RecordImageService.saveImage
      if (this.source === 'course') {
        fn = RecordCourseService.saveImage
      }
      fn(img).then(img => {
        img = img.result
        img.thumbnail = service.url(img.thumbnail)
        img.image = service.url(img.image)
        let index = _.findIndex(this.files, {'tempid': data.id})
        if (index < 0) {
          return
        }
        this.$set(this.files, index, _.clone(img))
      }).catch(error => {
        this.$message.error(error || '添加图片失败')
      })
    },
    handleChangeFileStatus (file, fileList) {
      if (file.status === 'success') {
        _.remove(fileList, function (item) {
          return item.uid === file.uid
        })
      }
    },
    clearImages () {
      let idkey = 'rid'
      if (this.source === 'course') {
        idkey = 'dcid'
      }
      if (_.isEmpty(this.files)) {
        return
      }
      for (let i = 0; i < this.files.length;) {
        if (this.files[i][idkey] && this.files[i][idkey] !== this.sourceId) {
          this.files.splice(i, 1)
          continue
        }
        if (this.sourceId && this.sourceId !== this.files[i][idkey]) {
          this.files.splice(i, 1)
          continue
        }
        i++
      }
    },
    saveImages () {
      let self = this
      return new Promise((resolve, reject) => {
        if (!self.sourceId) {
          reject(new Error('图片列表的主体为空'))
          return
        }
        let fn = RecordImageService.saveImage
        let idkey = 'rid'
        if (self.source === 'course') {
          fn = RecordCourseService.saveImage
          idkey = 'dcid'
        }
        let ps = []
        _.forEach(self.files, img => {
          if (!img.id || !img[idkey]) {
            let temp = _.cloneDeep(img)
            temp.classify = self.classify
            temp[idkey] = self.sourceId
            temp.thumbnail = img.thumbnail.replace(service.BasePath(), '')
            temp.image = img.image.replace(service.BasePath(), '')
            ps.push(fn(temp))
          }
        })
        Promise.all(ps).then(() => {
          resolve()
          this.$emit('saveImagesDone')
        }).catch(error => {
          reject(error || new Error('保存图片失败'))
          this.$emit('saveImagesFail', error)
        })
      })
    },
    handleShareLinkClick (index, e, target) {
      /*console.log(index)
      console.log(e)
      console.log(target)*/
      if (index < 0) {
        return
      }
      if (target.innerHTML === '备注') {
        let imgObj = this.files[index]
        this.$prompt('', '批注', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder: '请输入内容',
          inputType: 'textarea',
          inputValue: imgObj ? imgObj.remark : null,
          inputPattern: /\S+/,
          inputErrorMessage: '内容不能为空'
        }).then(({ value }) => {
          if (!imgObj) {
            return
          }
          let fn = RecordImageService.saveImage
          if (this.source === 'course') {
            fn = RecordCourseService.saveImage
          }
          imgObj.remark = value
          fn(imgObj).then(res => {
            let img = res.result
            img.thumbnail = service.url(img.thumbnail)
            img.image = service.url(img.image)
            this.$set(this.files, index, _.clone(img))
            this.$message({
              message: '备注成功',
              type: 'success'
            })
          }).catch(error => {
            this.$message.error(error || '备注失败')
          })
        }).catch(() => {
          this.$message({
            message: '取消操作',
            type: 'info'
          })
        })
      }
    },
    handlePreview (file) {
      let index = _.findIndex(this.files, {'id': file.id})
      this.vpsoptions.index = index
      this.$emit('preView', {index: index, classify: this.classify})
      this.showPhotoSwipe = true
    },
    handleSortFiles (file, newIndex, oldIndex) {
      if (!this.sourceId) {
        return
      }
      if (newIndex === oldIndex) {
        return
      }
      let i = 1
      let fn = RecordImageService.saveImage
      if (this.source === 'course') {
        fn = RecordCourseService.saveImage
      }
      _.forEach(this.files, file => {
        if (file.orderNum !== i) {
          file = _.cloneDeep(file)
          file.orderNum = i
          file.thumbnail = file.thumbnail.replace(service.BasePath(), '')
          file.image = file.image.replace(service.BasePath(), '')
          file['_index'] = i - 1
          fn(file).then(img => {
            img = img.result
            img.thumbnail = service.url(img.thumbnail)
            img.image = service.url(img.image)
            this.$set(this.files, file['_index'], _.clone(img))
          })
        }
        i++
      })
    }
  }
}
</script>

<template>
  <div class="eber-file-wrap clear">
    <eber-files
      v-if="files.length > 0"
      v-model="files"
      :custom-class="vpsoptions.thumbnailParentClass"
      :handlePreview="handlePreview"
      :disabled="disabled"
      @remove="handleDeleteImage"
      @remark="handleRemarkImage"
      @sort="handleSortFiles"
    >
    </eber-files>
    <p v-if="files.length <= 0 && disabled && !enableAdd" class="none-image">暂无图片</p>
    <el-upload
      v-if="enableAdd"
      action="upload"
      accept="*"
      multiple
      :http-request="handleUploadImage"
      :on-success="handleUploadImageSuccess"
      :on-change="handleChangeFileStatus"
      :before-upload="handleBeforeUpload"
      list-type="picture-card">
      <i class="el-icon-plus"></i>
    </el-upload>
    <eber-photo-viewer
      v-if="showPhotoSwipe && showImages"
      :images="files"
      :show-index="vpsoptions.index"
      @close="showPhotoSwipe=false">
    </eber-photo-viewer>
<!--    <vue-photo-swipe :options="vpsoptions" :images="files" :thumbnailElementSelection="'.' + vpsoptions.thumbnailParentClass + ' .eber-file-list__item'" :show="showPhotoSwipe" @close="showPhotoSwipe=false" @shareLinkClick="handleShareLinkClick"></vue-photo-swipe>-->
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.eber-file-wrap {
}
.none-image {
  text-align: center;
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 148px;
  height: 148px;
  line-height: 148px;
  margin: 0 8px 8px 0;
  display: inline-block;
}
.m-box {
    -webkit-box-shadow: 0 0 0 #000;
    -moz-box-shadow: 0 0 0 #000;
    box-shadow: 0 0 0 #000;
}
</style>
